import { GET_SUBSCRIPTION_LIST } from 'root-redux/actions/common'

import { usePurchaseStore } from './usePurchaseStore'

export const usePricesStatus = () => {
  const { fetchingActionsList, subscriptions } = usePurchaseStore()
  const arePricesReady =
    !fetchingActionsList?.includes(GET_SUBSCRIPTION_LIST) &&
    !!subscriptions.length

  return { arePricesReady }
}
